// Markers the major mail clients leave around a quoted reply chain.
const QUOTE_SELECTOR = [
  '.gmail_quote',
  '.moz-cite-prefix',
  '.yahoo_quoted',
  'blockquote[type="cite"]',
  '#appendonsend',
  '#divRplyFwdMsg',
].join(',')

const parseBody = (html) => new DOMParser().parseFromString(html, 'text/html').body

// Walks marker -> body, stripping siblings in one direction at every level.
const trimSiblings = (marker, body, direction) => {
  let node = marker
  while (node && node !== body) {
    const parent = node.parentNode
    while (node[direction]) parent.removeChild(node[direction])
    node = parent
  }
}

// Drops the marker and everything after it, keeping the ancestors that still hold earlier content.
const keepBefore = (marker, body) => {
  trimSiblings(marker, body, 'nextSibling')
  marker.parentNode.removeChild(marker)
}

// Keeps the marker and everything after it, dropping earlier siblings at every level.
const keepFrom = (marker, body) => trimSiblings(marker, body, 'previousSibling')

/**
 * Splits an email body into the new content and the quoted chain below it.
 * Returns the whole body as visible when there is no quote, or when trimming would leave nothing.
 */
export const splitQuotedHtml = (html) => {
  if (!html) return { visibleHtml: '', quotedHtml: '' }

  const visibleBody = parseBody(html)
  const marker = visibleBody.querySelector(QUOTE_SELECTOR)
  if (!marker) return { visibleHtml: html, quotedHtml: '' }

  keepBefore(marker, visibleBody)
  // textContent misses image-only replies, so also count embedded media as real content.
  const hasContent = visibleBody.textContent.trim() || visibleBody.querySelector('img, video, audio')
  if (!hasContent) return { visibleHtml: html, quotedHtml: '' }

  const quotedBody = parseBody(html)
  keepFrom(quotedBody.querySelector(QUOTE_SELECTOR), quotedBody)

  return { visibleHtml: visibleBody.innerHTML, quotedHtml: quotedBody.innerHTML }
}
